import { useState } from "react";
import { useQuery } from "@apollo/client";
import Pusher from "pusher-js";
import { useEffect } from "react";
import { GQL_LOCAL_ME } from "../../apollo/query/user";
import { EventNames } from "../../constants/EventChannels";
import { localStorageClass } from "../../apollo/local/storage";
import { createNotification } from "../../util/notification";

const UserNotificationListener = () => {
   const { data } = useQuery(GQL_LOCAL_ME);

   const me = data?.me;

   useEffect(() => {
      if (me) {
         const setupPusher = async () => {
            const token = await localStorageClass.getToken();

            const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
               cluster: process.env.REACT_APP_PUSHER_CLUSTER,
               authEndpoint: `${process.env.REACT_APP_SERVER_URL}/pusher/auth`,
               auth: {
                  headers: {
                     Authorization: `Bearer ${token}`,
                  },
               },
            });

            const channelName = `private-user.${me.id}`;
            const channel = pusher.subscribe(channelName);

            channel.bind(EventNames.USER_NOTIFICATION, (data) =>
               createNotification(data)
            );

            //cleanup
            return () => {
               pusher.unsubscribe(channelName);
               pusher.disconnect();
            };
         };

         const cleanupPromise = setupPusher();

         // cleanup async
         return () => {
            cleanupPromise.then((cleanup) => {
               if (typeof cleanup === "function") cleanup();
            });
         };
      }
   }, [me]);

   return <></>;
};

const UserNotificationDispatcher = () => {
   const [permissionGranted, setPermissionGranted] = useState(false);

   useEffect(() => {
      if ("Notification" in window) {
         setPermissionGranted(Notification.permission === "granted");
      }
   }, []);
   return permissionGranted ? <UserNotificationListener /> : null;
};

export default UserNotificationDispatcher;
